import instance from '../instance';
import getLiveElement from './get-live-element';

const getParentLiveElementId = (childId) => {
  const childElement = getLiveElement(childId);
  if (!childElement) return null;

  return instance.driver.referenceMap.getParentReferenceId(childElement);
};

export default getParentLiveElementId;
